import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import moment from 'moment';

// Hooks

import GetWindowSize from '../../../../hooks/GetWindowSize';

// Components

import Button from '../../../UI/Button/Button';

// Images

import babyBoomer from './Images/img-intro-person-boomer.png';
import generationX from './Images/img-intro-person-genx.png';
import generationY from './Images/img-intro-person-geny.png';
import generationZ from './Images/img-intro-person-genz.png';

// Styles

import './Styles.scss';

export default function FormModuleIntro({ formik, modules, currentModule, handleSetShowModuleIntro, clientAge, goToPreviousModule }) {
    const { windowSize } = GetWindowSize();
    const dispatch = useDispatch();

    useEffect(() => {
        if (currentModule === 2 && !['1', '2', '3', '4'].includes(formik.values?.cliente?.tipoCliente)) {
            dispatch(handleSetShowModuleIntro(false));
        }
    }, [])

    const setClientAgeModuleIntroImage = () => {
        const birthDate = moment(clientAge);
        const age = moment().diff(birthDate, 'years');

        if (age > 57) {
            return babyBoomer;
        } else if (age <= 57 && age >= 42) {
            return generationX;
        } else if (age <= 41 && age >= 26) {
            return generationY;
        } else {
            return generationZ
        }
    }

    return (
        <div className='form-module-intro'>
            <div className='form-module-intro-container'>

                {windowSize?.innerWidth >= 769 ? (
                    <div className='form-module-intro-wrapper'>

                        <div className='form-module-intro-image'>
                            <img src={setClientAgeModuleIntroImage()} alt="" />
                        </div>

                        <div className='form-module-intro-info'>
                            <p>{currentModule + 1}</p>
                            <h2>{modules[currentModule]?.name}</h2>

                            <div className='form-module-intro-actions'>
                                {currentModule !== 0 &&
                                    <Button
                                        type="button"
                                        action={() => {
                                            goToPreviousModule(
                                                currentModule === 3 && ['5', '6'].includes(formik.values?.cliente?.tipoCliente)
                                                    ? currentModule - 2
                                                    : currentModule - 1
                                            );
                                            dispatch(handleSetShowModuleIntro(false));
                                        }}
                                        label={'Regresa'}
                                        secondaryStyle={true}
                                    />}
                                <Button
                                    type="button"
                                    action={() => dispatch(handleSetShowModuleIntro(false))}
                                    label={'Comienza'}
                                />
                            </div>
                        </div>

                    </div>
                ) : (
                    <div className='form-module-intro-wrapper'>

                        <div className='form-module-intro-info'>
                            <p>{currentModule + 1}</p>
                            <h2>{modules[currentModule]?.name}</h2>

                            <div className='form-module-intro-actions'>
                                {currentModule !== 0 &&
                                    <Button
                                        type="button"
                                        action={() => {
                                            goToPreviousModule(
                                                currentModule === 3 && ['5', '6'].includes(formik.values?.cliente?.tipoCliente)
                                                    ? currentModule - 2
                                                    : currentModule - 1
                                            );

                                            dispatch(handleSetShowModuleIntro(false));
                                        }}
                                        label={'Regresa'}
                                        secondaryStyle={true}
                                    />}
                                <Button
                                    type="button"
                                    action={() => dispatch(handleSetShowModuleIntro(false))}
                                    label={'Comienza'}
                                />
                            </div>
                        </div>

                        <div className='form-module-intro-image'>
                            <img src={setClientAgeModuleIntroImage()} alt="" />
                        </div>

                    </div>
                )}
            </div>
        </div>
    )
}